import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

/**
 * Internal Formly FieldType Component
 * Used internally by TextAreaWrapperComponent and Formly forms.
 * Do not use this directly - use TextAreaWrapperComponent instead.
 */
@Component({
  selector: 'era-formly-text-area-field',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, ReactiveFormsModule, FormlyModule],
})
export class TextAreaComponent extends FieldType<FieldTypeConfig> {
  get placeholder(): string {
    return this.props.placeholder || '';
  }

  get required(): boolean {
    return this.props.required || false;
  }

  get disabled(): boolean {
    return this.props.disabled || false;
  }

  get readonly(): boolean {
    return this.props.readonly || false;
  }

  get maxLength(): number | undefined {
    return this.props.maxLength;
  }

  get minLength(): number | undefined {
    return this.props.minLength;
  }

  get rows(): number {
    return this.props.rows || 3;
  }

  get labelPosition(): 'top' | 'inline' {
    return this.props.labelPosition || 'top';
  }

  get labelWidth(): string | undefined {
    return this.props.labelWidth;
  }
}
